// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-modal-outer {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.employee-modal {
  width: 600px;
  background: #ffffff;
  border-radius: 16px;
  padding: 2%;
}
.employee-modal__modal-action__close {
  cursor: pointer;
}
.employee-modal__head {
  display: flex;
}
.employee-modal__head__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 36px;
  color: #333333;
}
.employee-modal__head__submit-time {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
}
.employee-modal__profile-image {
  margin-right: 20px;
}
.employee-modal__checklist {
  margin-top: 30px;
}
.employee-modal__checklist__item {
  display: flex;
  height: 56px;
  border-bottom: 1px solid #e9e9e9;
  align-items: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.employee-modal__checklist__item__item__text {
  margin-left: 10px;
}
.employee-modal__checklist__item__type {
  display: flex;
  margin-left: auto;
}
.employee-modal__checklist__item__type__text {
  margin-left: 6px;
}
.employee-modal__checklist__item__type__text-abnormal {
  margin-left: 6px;
  color: #bd1922;
}
.employee-modal__checklist__attachments {
  margin-top: 40px;
}
.employee-modal__checklist__attachments__head {
  display: flex;
  margin-bottom: 10px;
}
.employee-modal__checklist__attachments__head-text {
  margin-left: 6px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #999999;
}
.employee-modal__checklist__attachments__body {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
}
.employee-modal__checklist__attachments__images {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 auto;
}
.employee-modal__checklist__attachments__image {
  height: 100px;
  width: 100px;
  border-radius: 8px;
  flex: 0 0 90px;
  margin: 5px;
}
.employee-modal__checklist__memo {
  margin-top: 40px;
}
.employee-modal__checklist__memo__head {
  display: flex;
}
.employee-modal__checklist__memo__head-text {
  margin-left: 6px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #999999;
}
.employee-modal__checklist__memo__body {
  margin-top: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #505054;
}`, "",{"version":3,"sources":["webpack://./src/components/checklist/employee-modal/employee-modal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,mBAAA;EACA,mBAAA;EAEA,WAAA;AAAJ;AAGQ;EACI,eAAA;AADZ;AAKI;EACI,aAAA;AAHR;AAKQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHZ;AAMQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAJZ;AAQI;EACI,kBAAA;AANR;AASI;EACI,gBAAA;AAPR;AASQ;EACI,aAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARZ;AAWgB;EACI,iBAAA;AATpB;AAaY;EACI,aAAA;EACA,iBAAA;AAXhB;AAagB;EACI,gBAAA;AAXpB;AAcgB;EACI,gBAAA;EACA,cAAA;AAZpB;AAiBQ;EACI,gBAAA;AAfZ;AAiBY;EACI,aAAA;EACA,mBAAA;AAfhB;AAkBY;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhBhB;AAmBY;EACI,aAAA;EACA,eAAA;EACA,gBAAA;AAjBhB;AAoBY;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAlBhB;AAqBY;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EAEA,cAAA;EACA,WAAA;AApBhB;AAwBQ;EACI,gBAAA;AAtBZ;AAwBY;EACI,aAAA;AAtBhB;AAyBY;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAvBhB;AA0BY;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBhB","sourcesContent":[".employee-modal-outer {\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100;\n}\n\n.employee-modal {\n    width: 600px;\n    background: #ffffff;\n    border-radius: 16px;\n\n    padding: 2%;\n\n    &__modal-action {\n        &__close {\n            cursor: pointer;\n        }\n    }\n\n    &__head {\n        display: flex;\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 26px;\n            line-height: 36px;\n            color: #333333;\n        }\n\n        &__submit-time {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #999999;\n        }\n    }\n\n    &__profile-image {\n        margin-right: 20px;\n    }\n\n    &__checklist {\n        margin-top: 30px;\n\n        &__item {\n            display: flex;\n            height: 56px;\n            border-bottom: 1px solid #e9e9e9;\n            align-items: center;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            color: #333333;\n\n            &__item {\n                &__text {\n                    margin-left: 10px;\n                }\n            }\n\n            &__type {\n                display: flex;\n                margin-left: auto;\n\n                &__text {\n                    margin-left: 6px;\n                }\n\n                &__text-abnormal {\n                    margin-left: 6px;\n                    color: #bd1922;\n                }\n            }\n        }\n\n        &__attachments {\n            margin-top: 40px;\n\n            &__head {\n                display: flex;\n                margin-bottom: 10px;\n            }\n\n            &__head-text {\n                margin-left: 6px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 22px;\n                color: #999999;\n            }\n\n            &__body {\n                display: flex;\n                flex-wrap: wrap;\n                list-style: none;\n            }\n\n            &__images {\n                display: flex;\n                flex-wrap: wrap;\n                list-style: none;\n                margin: 0 auto;\n            }\n\n            &__image {\n                height: 100px;\n                width: 100px;\n                border-radius: 8px;\n\n                flex: 0 0 90px;\n                margin: 5px;\n            }\n        }\n\n        &__memo {\n            margin-top: 40px;\n\n            &__head {\n                display: flex;\n            }\n\n            &__head-text {\n                margin-left: 6px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 16px;\n                line-height: 22px;\n                color: #999999;\n            }\n\n            &__body {\n                margin-top: 15px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 16px;\n                line-height: 24px;\n                color: #505054;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
